interface TopicStatsProps {
  quantityRemaining?: number | null;
  quantitySold?: number | null;
  viewerCount?: number | null;
  viewerEffect?: "HOT" | null;
}

export class TopicStats implements TopicStatsProps {
  readonly quantityRemaining: number | null;
  readonly quantitySold: number | null;
  readonly viewerCount: number | null;
  readonly viewerEffect: "HOT" | null;

  public constructor(stats?: TopicStatsProps) {
    this.quantityRemaining = stats?.quantityRemaining || null;
    this.quantitySold = stats?.quantitySold || null;
    this.viewerCount = stats?.viewerCount || null;
    this.viewerEffect = stats?.viewerEffect || null;
  }
}
